import { DRUG_TYPE } from './med';
import { PRESCRIPT_STATUS } from './order';

export enum PopupTitleConfig { // 弹框titleconfig
  USAGE = 100,
  SINGLEDOSE = 200,
  DRUGUSEFREQUENCY = 300,
  PRESCRIBINGUNIT = 400
}

export const PopupTitleConfigText = {
  [PopupTitleConfig.USAGE]: '用法',
  [PopupTitleConfig.SINGLEDOSE]: '单次剂量单位',
  [PopupTitleConfig.DRUGUSEFREQUENCY]: '用药频次',
  [PopupTitleConfig.PRESCRIBINGUNIT]: '购买药品单位'
};

export enum PrescriptionStatus {
  PROCESSING = 0,
  RISK = 1,
  FORBIDDEN = 2,
  OK = 3
}

export const PrescriptionStatusColor = {
  [PrescriptionStatus.PROCESSING]: 'green',
  [PrescriptionStatus.RISK]: 'yellow',
  [PrescriptionStatus.FORBIDDEN]: 'red',
  [PrescriptionStatus.OK]: 'blue'
};

export enum SendPrescriptionStatus {
  SENDSUCESS = 0,
  SENDFAILED = 1,
  SUBMITSUCESS = 2,
  SUBMITFAILED = 3
}

export enum HistoryDisease {
  pastMmedicalHistory,
  allergy,
  familyHistory,
  pregnancyBreastFeeding,
  liverFunction,
  renalFunction
}

export const HistoryDiseaseText = {
  [HistoryDisease.pastMmedicalHistory]: '过往病史',
  [HistoryDisease.allergy]: '过敏史',
  [HistoryDisease.familyHistory]: '家族疾病史',
  [HistoryDisease.pregnancyBreastFeeding]: '妊娠哺乳',
  [HistoryDisease.liverFunction]: '肝功能',
  [HistoryDisease.renalFunction]: '肾功能'
};

export enum ANSWER {
  NO,
  YES
}

export enum pregnancyBreast {
  PregnancyPrepared, // 备孕中
  InPregnancy, // 怀孕中
  BreastFeeding // 哺乳期
}

export const pregnancyBreastConfig = {
  备孕中: pregnancyBreast.PregnancyPrepared,
  怀孕中: pregnancyBreast.InPregnancy,
  正在哺乳: pregnancyBreast.BreastFeeding
};

export const pregnancyBreastText = {
  [pregnancyBreast.PregnancyPrepared]: '备孕中',
  [pregnancyBreast.InPregnancy]: '怀孕中',
  [pregnancyBreast.BreastFeeding]: '正在哺乳'
};

export const diseaseInfoKeyConfig = {
  allergy: 'amh',
  familyHistory: 'fmh',
  liverFunction: 'liverDesc',
  pregnancyBreastFeeding: 'nurseDesc',
  pastMmedicalHistory: 'pmh',
  renalFunction: 'renalDesc'
};

export const diseaseInfoResultConfig = {
  amh: 'allergy',
  fmh: 'familyHistory',
  liverDesc: 'liverFunction',
  nurseDesc: 'pregnancyBreastFeeding',
  pmh: 'pastMmedicalHistory',
  renalDesc: 'renalFunction'
};

export interface IDiseaseInfo {
  [key: string]: {
    answer: number;
    desc: string[] | string | number | undefined;
    selectedDesc: string[] | string | number | undefined;
  };
}

export interface IPatientInfo {
  patientAge: number | null;
  patientGender: number | null;
  patientIdCardNo: string;
  patientName: string;
  weight: string;
  hasBeenModified: boolean;
  hasVerified: boolean;
  userId: number;
}

export interface IDrugInfoVO {
  drugId: string;
  drugName: string;
  drugImg: string;
  drugType?: DRUG_TYPE;
  price?: number; // 单价
  frequencyUnit: string; // “次”
  frequencyValue: string; // “1次”
  days: number;
  doseUnit: string; // '片'
  doseValue: string; // “2片”,
  count: number;
  countUnit: string;
  spec: string; // 规格
  usage: string; // 用法
  approvalNo: string;
  commonName?: string;
  source: number;
  dosage: string;
  manufactureFactory?: string;
  stock: number;
  drugQtyUnit?: string;
}
export interface IPrescriptionPreviewInfoVO {
  aiAuditResult: IAiAuidtResult;
  name: string;
  sex: number;
  age: number;
  diseaseInfos: IDiseaseVo[]; // 诊断
  comment: string; // 医嘱
  drugInfos: IDrugInfoVO[];
  amh: string[];
  createTime: string;
  dealDesc: string;
  department: string;
  doctorId: number;
  doctorSignUrl: string;
  drugstoreSignUrl: string;
  fmh: string[];
  id: number;
  liverDesc: string[];
  nurseDesc: string[];
  orderFileUrl: string;
  orderId: number;
  organizationSignUrl: string;
  passTime: string;
  pharmacistSignUrl: string;
  pmh: string[];
  prescriberId: number;
  renalDesc: string[];
  rxNo: string;
  source: number;
  status: PRESCRIPT_STATUS;
  tpPrescriptionId: string;
  updateTime: string;
  userId: number;
  weight: string;
  checkSign: number;
}

export const initPrescriptionPreviewInfo = {
  aiAuditResult: {
    id: '',
    list: [],
    totalCheck: 0
  },
  name: '',
  sex: 0,
  age: 0,
  diseaseInfos: [
    {
      diseaseId: '',
      diseaseName: ''
    }
  ], // 诊断
  comment: '', // 医嘱
  drugInfos: []
};

export const initDoctorInfo = {
  avatar: '',
  sex: 0,
  bindCount: 0,
  nickname: '',
  resume: '',
  careerYear: 0,
  doctorId: '',
  goodProject: '',
  doctorName: ''
};

export interface IDiseaseVo {
  diseaseId: string;
  diseaseName: string;
}

export interface ISearchDrugVo {
  approvalNo: string;
  brand?: string;
  drugId: string;
  drugImg: string;
  drugName: string;
  manufactureFactory?: string;
  merchantShopSkuId?: string;
  price?: number;
  source: number;
  spec: string;
  stock: number;
  unitOfMeasurement?: string;
  commonName?: string;
  drugType?: number;
}

export interface IAddedDrugVo extends ISearchDrugVo {
  count?: number;
}

export interface IPatientInfoResult {
  amh: string[]; // 过敏史描述
  fmh: string[]; // 家族病描述
  hasBeenModified: boolean; // 用户或医生是否填写过病史
  liverDesc: string[]; // 肝功能描述
  nurseDesc: string; // 妊娠说明
  patientAge: number; // 患者年龄
  patientGender: number; // 患者性别: 0-女性, 1-男性
  patientIdCardNo: string; // 患者身份证号码
  patientName: string; // 患者姓名
  userId: number; // 就诊人快手id
  pmh: string[]; // 过往病描述
  renalDesc: string[]; // 肾功能描述
  weight: string; // 体重
  hasVerified: boolean; // 用户是否已实名
}

export interface IAiAuidt {
  color: string;
  msg: string;
  name: string;
  suggest: string;
  title: string;
}
export interface IAiAuidtResult {
  id: string;
  list: IAiAuidt[];
  totalCheck: number;
}

export interface IUserAttrList {
  id: string;
  userId: string;
  attrType: string;
  attrValue: string;
}

export const frequencyData = [
  [
    {
      label: '每天',
      value: '每天'
    },
    {
      label: '每周',
      value: '每周'
    },
    {
      label: '每月',
      value: '每月'
    },
    {
      label: '1小时',
      value: '1小时'
    },
    {
      label: '2小时',
      value: '2小时'
    },
    {
      label: '3小时',
      value: '3小时'
    },
    {
      label: '4小时',
      value: '4小时'
    },
    {
      label: '5小时',
      value: '5小时'
    },
    {
      label: '6小时',
      value: '6小时'
    }
  ],
  [
    {
      label: '1次',
      value: '1次'
    },
    {
      label: '2次',
      value: '2次'
    },
    {
      label: '3次',
      value: '3次'
    },
    {
      label: '4次',
      value: '4次'
    },
    {
      label: '5次',
      value: '5次'
    },
    {
      label: '6次',
      value: '6次'
    }
  ]
];
export interface IRecommendDoctorInfo {
  avatar: string; // 医生头像
  sex: number; // 0女性|1男性
  bindCount: number; // 绑定医生数量
  nickname: string; // 医生昵称
  resume: string; // 医生简介
  careerYear: number; // 医生从业年限
  doctorId: string; // 医生快手ID
  goodProject: string; // 医生擅长
  doctorName: string; // 医生姓名
}
export interface ISendPrescriptionResult {
  needBindPrescriber: boolean;
  recommendPrescriber: IRecommendDoctorInfo;
}

// 处方详情相关的interface
export interface IPrescriptionDetailResult {
  // 一、处方状态
  id: number; // 处方id
  tpPrescriptionId: string; // 卡片上显示的id
  status: number; // 处方状态, 0-预开方, 100-已发送, 200-开方医生开方待审, 300-审核通过, 400-审核拒绝, 500-已取消, 600-已过期, 700-已使用, 800-已退款
  expireTime?: string; // 处方过期时间
  dealDesc?: string; // 医生拒方原因
  // 二、患者信息和处方图片
  name: string; // 患者姓名
  sex: number; // 患者性别:0女性|1男性
  age: number; // 患者年龄
  department: number; // 科室
  createTime: string; // 创建时间
  orderFileUrl: string; // 处方图片
  // 三、诊断
  diseaseInfos: IDiseaseVo[]; // 疾病诊断
  // 四、药品卡片列表
  drugInfos: IDrugInfoVO[];
  // 五、补充说明
  comment: string; // 补充说明
  // 六、盖章签名
  doctorSignUrl: string; // 医生签名图片地址
  pharmacistSignUrl: string; // 药师签名图片地址
  drugstoreSignUrl: string; // 药店审核签名图片地址
  organizationSignUrl: string; // 机构签章图片地址

  // 七、订单参数
  orderId: number; // 咨询订单ID
  tpOrderId?: string; // 有订单时的订单id
  paymentStatus?: number; // 订单支付状态, 0未支付 1待审核 2部分支付 3已支付
  // 八、角色id
  userId: number; // 用户快手ID
  doctorId: number; // 医生ID
  prescriberId: number; // 开方医生ID
}
export interface IPrescriptionDetailCardInfo {
  id: number; // 处方id
  tpPrescriptionId: string; // 卡片上显示的id
  status: number; // 处方状态, 0-预开方, 100-已发送, 200-开方医生开方待审, 300-审核通过, 400-审核拒绝, 500-已取消, 600-已过期, 700-已使用, 800-已退款
  expireTime?: string; // 处方过期时间
  dealDesc?: string; // 医生拒方原因
}
export interface IPrescriptionDetailPatientInfo {
  name: string; // 患者姓名
  sex: number; // 患者性别:0女性|1男性
  age: number; // 患者年龄
  department: number; // 科室
  createTime: string; // 创建时间
  orderFileUrl: string; // 处方图片
}
// 签名盖章相关图片地址
export interface ISignUrls {
  doctorSignUrl: string; // 医生签名图片地址
  pharmacistSignUrl: string; // 药师签名图片地址
  drugstoreSignUrl: string; // 药店审核签名图片地址
  organizationSignUrl: string; // 机构签章图片地址
}

// 处方的状态
export enum prescriptionOrderState {
  audit = 200, // 200-开方医生开方待审：审核中
  noUse = 300, // 300-审核通过：审核通过未使用
  failAudit = 400, // 400-审核拒绝：审核不通过
  invalidWithdraw = 500, // 500-已取消：医生撤回处方
  invalid = 600, // 600-已过期：处方过期
  used = 700 // 700-已使用：审核通过已使用
}

interface MedicineVO {
  content: string;
  name: string;
}
export interface IPrescriptionDrugDetail {
  drugId: string;
  drugName: string;
  drugUnitInfo: {
    countUnit: string;
    dosage: string;
    drugQtyUnit: string;
    doseUnit: string;
    doseValue: string;
    // N次
    frequencyUnit: string;
    // N天
    frequencyValue: string;
  };
  instructions: MedicineVO[];
  source: number;
}

export enum IDrugType {
  RX = 1,
  OTC = 2,
  OTHER = 3
}

export const DrugTypeName = {
  [IDrugType.RX]: '处方药',
  [IDrugType.OTC]: '非处方药',
  [IDrugType.OTHER]: '其他'
};

export enum RoleType {
  patient, // 0-患者
  doctor, // 1-医生
  prescriptionDoctor, // 2-处方医生
  unknown // 3-未知
}
